// @spec AUD-STR-031
// Evidence library page route

import { createFileRoute } from '@tanstack/react-router';

import { EvidenceLibrary } from '@/features/evidence/components/EvidenceLibrary';

export const Route = createFileRoute('/_authenticated/audit/evidence-library')({
  component: EvidenceLibraryPage,
});

function EvidenceLibraryPage() {
  return (
    <div className="p-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold">Audit & Assurance</h1>
          <p className="mt-2 text-muted-foreground">
            Use Evidence Library as a single evidence hub linked to controls, regulations, assets,
            risks, vulnerabilities, training, and policies.
          </p>
        </div>

        <EvidenceLibrary />
      </div>
    </div>
  );
}
